<template>
    <span
        class="text-sm text-gray-400"
        data-spec-class="card_list-subtitle"
    >
        <slot></slot>
    </span>
</template>
